import { useEffect } from "react";
import { useMail } from "../contexts/mailContext/mailContext.js";
import { useUser } from "../contexts/userContext/userContext.js";
import { useInView } from "react-intersection-observer";
import useMailSender from "./useMailSender.js";

const usePagination = () => {
  const {
    getFilesLoading,
    getPageNumber,
    getIsFetchMore,
    incPageNumber,
    fetchMailFiles,
  } = useMail();

  const { isBusiness, isPremium } = useUser();
  const { isMailSenderAndBusinessSubscriber } = useMailSender();

  const { ref, inView } = useInView();

  let throttle = null;

  // callback function to inc page number
  const callBackFunc = (customTrigger = false) => {
    return (customTrigger || inView) && getIsFetchMore() && incPageNumber();
  };

  // trigger
  const triggerFunction = (customTrigger = false) => {
    if (throttle === null && !customTrigger) {
      throttle = setTimeout(callBackFunc, 100);
    }
    if (customTrigger) {
      callBackFunc(customTrigger);
    }
  };

  // recall trigger func on some changes
  useEffect(() => {
    if (!inView || getFilesLoading()) return;
    triggerFunction();
  }, [inView, getFilesLoading(), throttle]);

  // fetch more files when user is on pageing
  useEffect(() => {
    if (getPageNumber() > 1) {
      fetchMailFiles({
        ad:
          getPageNumber() > 1
            ? isBusiness() || isPremium() || isMailSenderAndBusinessSubscriber()
              ? false
              : true
            : false,
      });
    }
  }, [getPageNumber()]);

  return {
    triggerFunction,
    ref,
    hasMoreToFetch: getIsFetchMore(),
  };
};

export default usePagination;
